var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from 'path-shared/models/filter-data';
var SenalesVerticalesFilter = /** @class */ (function (_super) {
    __extends(SenalesVerticalesFilter, _super);
    function SenalesVerticalesFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.id = '';
        _this.nombreSenal = '';
        _this.tipoFk = '';
        _this.labels['id'] = _this.i18n('Id');
        _this.labels['nombreSenal'] = _this.i18n('Nom');
        _this.labels['tipoNombre'] = _this.i18n('Tipus');
        _this.labels['tipoFk'] = _this.i18n('TipusFK');
        return _this;
    }
    return SenalesVerticalesFilter;
}(FilterData));
export { SenalesVerticalesFilter };
